import { useContext } from 'react';
import { SesionContext, type SesionContextValue } from './sesionContexto';

/**
 * La sesión del área de inversionistas.
 *
 * **Esto es lo que importan las pantallas.** Nunca un adaptador, nunca
 * `elPuerto`: `soloElPuerto.test.ts` falla si alguna lo hace, y su mensaje de
 * error manda aquí.
 *
 * Lanza si falta el proveedor, por lo escrito en `sesionContexto.ts`: un `null`
 * silencioso se vería igual que «no has entrado».
 */
export function useSesion(): SesionContextValue {
  const valor = useContext(SesionContext);
  if (valor === null) {
    throw new Error('useSesion necesita <SesionProvider> por encima.');
  }
  return valor;
}
